// extracted by mini-css-extract-plugin
export default {"heading":"created-quotes_heading__5WaRx","container":"created-quotes_container__X580M","describe":"created-quotes_describe__DlHoc","actions":"created-quotes_actions__hP+Yf"};